<template>
  <section class="hero hero-main is-fullheight cpe-main">
    <transition name="blur" mode="out-in">
      <overlay-loading v-if="cargando" />
    </transition>
    <transition name="bg" mode="out-in">
      <img class="bg" v-if="fondo" :src="fondo" alt />
    </transition>
    <nav
      class="navbar is-transparent"
      role="navigation"
      aria-label="dropdown navigation"
    >
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <img src="@/assets/logo-cpe-2.png" alt width="auto" height="auto" />
        </router-link>
        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" v-if="valido">
        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">Docente</a>
            <div class="navbar-dropdown is-boxed is-right">
              <a class="navbar-item">Acciones...</a>
              <hr class="navbar-divider" />
              <a
                class="navbar-item has-text-danger"
                href="#"
                @click.prevent="salir"
              >
                Salir
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="hero-body">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <!-- <router-view/> -->
    </div>
    <div class="contenedor1">
      <div class="contenido1">
        <img src="@/assets/logo-mintic.png" alt width="auto" height="auto" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import OverlayLoading from "./components/OverlayLoading";
import axios from "axios";
export default {
  name: "app",
  components: { OverlayLoading },
  data() {
    return {};
  },
  computed: {
    cargando() {
      return this.$store.getters.getCargandoRuta;
    },
    valido() {
      return this.$store.getters.valida;
    },
    ...mapGetters({
      estrategia: "getEstrategia",
      plainestrategia: "estrategia"
    }),
    fondo() {
      let fondo = false;
      if (!(this.estrategia == undefined)) {
        fondo = this.estrategia.foto_2;
      }
      return fondo;
    }
  },
  methods: {
    salir() {
      this.$store.commit("salir");
      this.$router.push({
        name: "inicio",
        replace: true
      });
    }
  },
  created() {},
  mounted() {
    // Consultar los diplomados disponibles
    // this.$store.dispatch("fetchEstrategias");
    this.$globalEventBus.$on("salir", () => {
      this.salir();
    });
    // Interceptor Global
    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response == undefined) {
          alert(error.message);
          return Promise.reject(error);
        }

        // si el error es 401 (no autenticado) cerrar sesion en el aplicativo
        switch (error.response.status) {
          case 401:
          case 403:
          case 404:
          case 405:
          case 406:
            alert(error.response.statusText, error.response.data.message);
            break;
          case 500:
          case 501:
          case 502:
          case 503:
          case 504:
          case 505:
          case 506:
          case 507:
          case 508:
          case 509:
          case 510:
          case 511:
          case 598:
          case 599:
            alert(error.response.statusText, error.response.data.message);
            break;
          default:
            break;
        }
        // Retornar el error como promise para resolver
        return Promise.reject(error);
      }
    );
  }
};
</script>

<style lang="scss">
html,
body {
  font-family: "Arial", serif;
  font-size: 14px;
  font-weight: 300;
  overflow: auto;
}

.bg {
  position: fixed;
  height: 100%;
  width: auto;
  right: 0px;
  z-index: -1;
  will-change: transform;
}
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.hero.hero-main {
  background: #f2f6fa;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  top: 0px;
  left: 0px;
  margin: 0px;
  // Futuro cambio de fondo
  // background: linear-gradient(to bottom, rgba(89,0,255,1) 0%, rgba(0,235,252,1) 100%);
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
// .navbar-brand > .navbar-item > img {
// max-height: 70px !important;
// }
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}

.blur-enter-active,
.blur-leave-active {
  transition: backdrop-filter 1s, opacity 1s;
}
.blur-enter, .blur-leave-to /* .fade-leave-active below version 2.1.8 */ {
  backdrop-filter: blur(0px);
  opacity: 0;
}

.bg-enter-active,
.bg-leave-active {
  transition: transform 600ms 600ms;
}
.bg-enter, .bg-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
}

/*flip transition*/
.flip-enter-active,
.flip-leave-active {
  transition: transform 300ms linear;
  transform-style: preserve-3d;
}
.flip-enter {
  transform: perspective(1000px) rotateY(90deg);
  transform-style: preserve-3d;
}
.flip-leave-to {
  transform: perspective(1000px) rotateY(-90deg);
  transform-style: preserve-3d;
}

// input[type="date"]::-webkit-calendar-picker-indicator {
// display: none
// padding: 0px;
// margin: 0px;
// margin-left: -10px;
// margin-right: -10px;
// }

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  // margin: 0;
}

.cpe-main {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: right !important;
}

.contenedor1 {
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  text-align: center;
}
.contenido1 {
  max-width: 250px;
  max-height: 250px;
  display: inline-block;
}
</style>
